import React from "react";
import CardGeneric from "../../../../shared/components/generic/card/card-generic";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";

const formatCurrency = value => MonetaryUtils.formatCurrency(value);

const AssessmentSummaryCards = ({ cards = [] }) => (
	<div className="apuracao__summary-grid">
		{cards.map(card => {
			const Icon = card.icon;
			const hasSingleValue = card.value !== undefined && card.value !== null;

			return (
				<CardGeneric
					key={card.key}
					compact
					className="apuracao-summary-card"
					bodyClassName="apuracao-summary-card__body"
				>
					<div
						className={[
							"apuracao-summary-card__icon",
							`apuracao-summary-card__icon--${card.iconVariant}`
						].join(" ")}
					>
						<Icon />
					</div>

					<div className="apuracao-summary-card__content">
						<h3 className="apuracao-summary-card__title">
							{card.title}
						</h3>

						{hasSingleValue ? (
							<>
								<strong className="apuracao-summary-card__month-value">
									{formatCurrency(card.value)}
								</strong>

								<span className="apuracao-summary-card__label">
									{card.description}
								</span>
							</>
						) : (
							<>
								<strong className="apuracao-summary-card__month-value">
									{formatCurrency(card.monthValue)}
								</strong>

								<span className="apuracao-summary-card__label">
									Mês
								</span>

								<strong className="apuracao-summary-card__quarter-value">
									{formatCurrency(card.quarterValue)}
								</strong>

								<span className="apuracao-summary-card__label">
									Trimestre
								</span>
							</>
						)}
					</div>
				</CardGeneric>
			);
		})}
	</div>
);

export default AssessmentSummaryCards;